// extracted by mini-css-extract-plugin
export default {"logo":"logo--Wo7QR"};